<template>
    <div class="d-table w-100">
        <div v-tooltip="info.tooltip" class="d-table-cell text-left px-0">
            {{ info.label }}
        </div>
        <div class="d-table-cell text-right px-0">
            <div class="d-inline-block">
                <AppConfirmationPopover message="Delete action?" :action="onActionDelete">
                    <span class="text-danger clickable">
                        <i class="fal fa-trash-alt"></i>
                    </span>
                </AppConfirmationPopover>
            </div>
        </div>
    </div>
</template>

<script>
import {fieldActionModels} from '../../../../../../../../types/document-viewer/field/modules/action'
import AppConfirmationPopover from '../../../../../../../../components/shared/AppConfirmationPopover'

export default {
    name: 'FieldActionItem',
    components: {AppConfirmationPopover},
    props: {
        action: {
            type: Object, // FieldAction
            required: true
        }
    },
    computed: {
        info() {
            return fieldActionModels.find(a => a.name === this.action.name)
        }
    },
    methods: {
        onActionDelete() {
            this.$emit('delete', this.action)
        }
    }
}
</script>

<style scoped>

</style>
